var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningTriangleFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 41,
    viewBox: "0 0 48 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9727 35.2754L27.252 3.2832C25.7578 0.822266 22.1543 0.822266 20.748 3.2832L1.93945 35.2754C0.533203 37.7363 2.29102 40.8125 5.19141 40.8125H42.7207C45.6211 40.8125 47.3789 37.7363 45.9727 35.2754ZM21.8906 13.3906C21.8906 12.248 22.7695 11.2812 24 11.2812C25.1426 11.2812 26.1094 12.248 26.1094 13.3906V24.6406C26.1094 25.8711 25.1426 26.75 24 26.75C22.9453 26.75 21.8906 25.8711 21.8906 24.6406V13.3906ZM24 35.1875C22.418 35.1875 21.1875 33.957 21.1875 32.4629C21.1875 30.9688 22.418 29.7383 24 29.7383C25.4941 29.7383 26.7246 30.9688 26.7246 32.4629C26.7246 33.957 25.4941 35.1875 24 35.1875Z",
    fill: "#D60000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangleFilled);
export default __webpack_public_path__ + "static/media/warning-triangle-filled.c297dffe054ca694af1917b4371f1258.svg";
export { ForwardRef as ReactComponent };